
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://wdehpuppuhanqtsrzxok.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndkZWhwdXBwdWhhbnF0c3J6eG9rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcwNzEwNzksImV4cCI6MjA2MjY0NzA3OX0.xtWYXEsuMhynfYC7NVkSo_D01mm4dU55fWd5o0U6lKk';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
